import {
  usePageNotifications,
  type PageNotification,
  type PageNotificationTone,
  type PushPageNotificationInput,
} from './usePageNotifications';

export type DemPageNotificationTone = PageNotificationTone;
export type DemPageNotification = PageNotification;
export type PushDemPageNotificationInput = PushPageNotificationInput;

export function pushBannerAsNotification(
  push: (input: PushDemPageNotificationInput) => void,
  banner: { tone: 'ok' | 'warn' | 'neutral'; lines: string[] },
) {
  if (banner.lines.length === 0) return;
  push({
    tone: banner.tone,
    title: banner.lines[0]!,
    lines: banner.lines.slice(1),
  });
}

export function useDemPageNotifications() {
  return usePageNotifications();
}
